import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import Facade from "@/Facade";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import SubmarineConfig from "@/config/SubmarineConfig";
import {TweenMax, Sine, Expo} from "gsap";

export default class PlatformContainer extends BaseContainer {

    static DEBUG = false

    constructor(data = null) {
        super(data)
        this.init()
    }

    init(data) {

        this.arr =  PlatformContainer.DEBUG ? [] : SubmarineConfig.land
        //Signals.stopFly.add(this.stop, this)
        Signals.makeBets.add(this.onMakeBets, this)
        Signals.roundStart.add(this.start, this)
        Signals.roundEnd.add(this.stop, this)

        this.container = new PIXI.Container()
        this.addChild(this.container)

        const sky = new PIXI.Sprite(PIXI.Texture.from('sky2'))
        this.container.addChild(sky)
        const reef = new PIXI.Sprite(PIXI.Texture.from('reef'))
        reef.position.set(-650, 100)
        this.container.addChild(reef)
        this.container.visible = true

        this.container.position.set(0, 0)
        //this.container.visible = false
    }

    onMakeBets() {
        console.log('platform onMakeBets')
        this.stop()
        this.container.position.set(0, 0)
        this.container.visible = true
    }

    start() {

        if(PlatformContainer.DEBUG) {
            this.arr.length = 0
            TweenMax.to(this.container, 11, {x: -600, y: -600, ease: Sine.easeInOut, onComplete: () => {
                    console.log(this.arr)
                }})
            Signals.tick.add(this.update, this)
            return
        }
        this.a = Math.round(Facade.model.deltaTime * 60)
        if (Facade.model.deltaTime < 0 || this.a >= this.arr.length - 1) {
            this.a = this.arr.length - 1
            const o = this.arr[this.arr.length - 1]
            this.container.y = o.y
            this.container.x = o.x
            this.container.visible = true
            return
        }
        this.container.visible = true

        Signals.tick.add(this.update, this)
    }

    stop() {
        if(PlatformContainer.DEBUG) {
            TweenMax.killTweensOf(this.container)
        }
        Signals.tick.remove(this.update, this)
    }

    update() {

        if(PlatformContainer.DEBUG) {
            const a = {
                x: Number(this.container.x.toFixed(2)),
                y: Number(this.container.y .toFixed(2))
            }
            this.arr.push(a)
            return
        }
        const o = this.arr[this.a]
        if (!o) console.log("ERROR", this.a, o)
        this.container.y = o.y
        this.container.x = o.x
        this.a++
        if (this.a == this.arr.length) {
            this.a = this.arr.length - 1
            this.stop()
        }
    }
}
